import React, { useEffect, useMemo } from "react";
import { marked } from "marked"
import { markedHighlight } from "marked-highlight";
import hljs from 'highlight.js'
import 'highlight.js/styles/github.css';
import "./opMarkdown.scss"
import { documentUtil } from "@/utils"

type PropsType = {
	md?: string
}
const renderer = new marked.Renderer()
// renderer.html = (html) => {
// 	html = html.replace(/src="https?:\/\/ppm.thape.com.cn/g, `src="`)
// 	return html
// }
// renderer.blockquote = (quote: string) => {
// 	return `<blockquote class="blockquote">${quote}</blockquote>`
// }
// marked.setOptions({
// 	renderer
// })
const highlight = markedHighlight({
	highlight: function (code, lang) {
		return hljs.highlightAuto(code).value;
	},
})
marked.use(highlight)

function removeWidthStyle(input: string) {
	// 使用正则表达式匹配并移除width声明
	return input.replace(/style\s*=\s*['"](.*?)['"]/g, "");
}

const Markdown: React.FC<PropsType> = ({ md }) => {
	
	const htmlClick = (e: any) => {
		if (e.target.nodeName === "IMG") {
			e.stopPropagation()
			const imgUrl = e.target.src
			let domain = window.location.origin
			const transferUrl = `${domain}/workbenchApi/op/getImage?url=${imgUrl}`
			// wx && wx.previewImage({
			// 	current: 0,
			// 	urls: [transferUrl]
			// })
		}else if(e.target.nodeName === "A") {
			const href = e.target.href
			if(href.startsWith(documentUtil.ppmPrefix) || href.startsWith("/")) {
				e.preventDefault()
				window.open(href, "_blank")
			}
		}
	}
	const markdownHtml = useMemo(() => {
		if (!md) return ""
		let html = marked.parse(md) as string
		html = html.replaceAll(`src="/api/v3/attachments`, `src="/workbenchApi/api/v3/attachments`)
		html = html.replaceAll(`href="/th_work_packages/edoc_files`, `href="${documentUtil.ppmPrefix}/th_work_packages/edoc_files`)
		html = removeWidthStyle(html)
		return html
	}, [md])
	return (
		<div className="op-md-box" onClick={htmlClick}  dangerouslySetInnerHTML={{__html: markdownHtml}}></div>
	)
}
export default Markdown
